import React, { Fragment } from 'react'
import CSS from './LandingPage.module.css';


function Footer() {
    return (
        <Fragment>
        <div className={CSS.footer}>
            <li>About Us</li>
            <li>Contact us</li>
            <li>Careers</li>
            <li>Internships</li>
        </div>
        <p className="text-center text-secondary" style={{backgroundColor: 'rgba(7, 5, 5, 0.945)',paddingBottom : '1rem'}}>&copy; Developed by Mohit Tiwari</p>
        </Fragment>
    )
}

export default Footer
